import apiClient from './api';

export const procesoService = {
  // Listar todos los procesos con paginación
  getAllProcesos: async (params = {}) => {
    const { page = 0, size = 5, sortBy, direction } = params;
    let url = `/procesos?page=${page}&size=${size}`;
    
    if (sortBy && direction) {
      url += `&sortBy=${sortBy}&direction=${direction}`;
    }
    
    const response = await apiClient.get(url);
    return response.data;
  },

  // Listar todos los procesos (sin paginación - método original)
  getAllProcesosSinPaginacion: async () => {
    const response = await apiClient.get('/procesos');
    return response.data;
  },

  // Obtener proceso por ID
  getProcesoById: async (id) => {
    const response = await apiClient.get(`/procesos/${id}`);
    return response.data;
  },

  // Crear nuevo proceso
  createProceso: async (procesoData) => {
    const response = await apiClient.post('/procesos', procesoData);
    return response.data;
  },

  // Actualizar proceso
  updateProceso: async (id, procesoData) => {
    const response = await apiClient.put(`/procesos/${id}`, procesoData);
    return response.data;
  },

  // Eliminar proceso
  deleteProceso: async (id) => {
    const response = await apiClient.delete(`/procesos/${id}`);
    return response.data;
  },

  // Asignar usuarios a un proceso
  asignarUsuariosAProceso: async (procesoId, usuariosIds) => {
    const response = await apiClient.post(`/procesos/${procesoId}/asignar-usuarios`, {
      usuariosIds: usuariosIds
    });
    return response.data;
  },

  // Asignar un solo usuario a un proceso
  asignarUsuarioAProceso: async (procesoId, usuarioId) => {
    const response = await apiClient.post(`/procesos/${procesoId}/asignar-usuario/${usuarioId}`);
    return response.data;
  },

  // Obtener usuarios asignados a un proceso desde usuario-proceso
  getUsuariosPorProceso: async (procesoId) => {
    const response = await apiClient.get(`/usuario-proceso/proceso/${procesoId}/usuarios`);
    return response.data;
  },

  // Obtener estadísticas de usuarios por proceso
  getEstadisticasUsuariosProceso: async (procesoId) => {
    const response = await apiClient.get(`/usuario-proceso/estadisticas/proceso/${procesoId}`);
    return response.data;
  },

  // Obtener procesos asignados a un usuario directamente
  getProcesosPorUsuario: async (usuarioId) => {
    const response = await apiClient.get(`/procesos/usuario/${usuarioId}`);
    return response.data;
  },
};

export default procesoService;
